import React from 'react';
import TestimonialCard from './TestimonialCard';
import styles from './Testimonials.module.scss';

const testimonialData = [
  {
    avatar: "https://cdn.builder.io/api/v1/image/assets/TEMP/9cf47b51c648589f18f736457de80eabdd957f2d4324d084231b5e5c0df5cfc8?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05",
    name: "Maya Chen",
    role: "Visual Story Artist & Novelist",
    title: "The Best Visual Storytelling Platform",
    description: "Troak offers breathtaking visuals, immersive stories, and an intuitive interface. It's the ultimate platform for experiencing and creating unforgettable visual stories.",
    showMore: true
  },
  {
    avatar: "https://cdn.builder.io/api/v1/image/assets/TEMP/5e7ae05761a94f7940037edb21493966f32729ba849ee93c7c777cfb5163513f?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05",
    name: "Regina King",
    role: "Bestselling Romance Author",
    title: "The Ultimate Platform for Writers and Readers",
    description: "Troak redefines storytelling with unmatched quality and diverse genres. A revolutionary platform for writers to captivate readers and bring stories to life.",
    showMore: false
  },
  {
    avatar: "https://cdn.builder.io/api/v1/image/assets/TEMP/5e7ae05761a94f7940037edb21493966f32729ba849ee93c7c777cfb5163513f?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05",
    name: "Athena Rose",
    role: "Screenwriter & Interactive Story Creator",
    title: "Revolutionary AI Script-to-Visual Conversion",
    description: "Troak's AI transforms scripts into stunning visual stories in minutes, revolutionizing creativity and saving time. No other platform comes close.",
    showMore: false
  },
  {
    avatar: "https://cdn.builder.io/api/v1/image/assets/TEMP/5e7ae05761a94f7940037edb21493966f32729ba849ee93c7c777cfb5163513f?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05",
    name: "AMCD_Fairy",
    role: "",
    title: "Amazing!! LOVE IT",
    description: "Dive into the 'Game of Games' Universe Immerse yourself in a rich and ever-expanding ecosystem where a vibrant array.",
    showMore: false
  },
  {
    avatar: "https://cdn.builder.io/api/v1/image/assets/TEMP/9cf47b51c648589f18f736457de80eabdd957f2d4324d084231b5e5c0df5cfc8?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05",
    name: "Maya Chen",
    role: "Visual Story Artist & Novelist",
    title: "The Best Visual Storytelling Platform",
    description: "Troak offers breathtaking visuals, immersive stories, and an intuitive interface. It's the ultimate platform for experiencing and creating unforgettable visual stories.",
    showMore: true
  },
];

const TestimonialsSection = () => {
  return (
    <section className={styles.testimonialSection}>
      <div className={styles.testimonialContainer}>
        <h2 className={styles.sectionTitle}>
          PLAYERS <span className={styles.highlightText}>LOVE US</span>
        </h2>
        <div className={styles.testimonialGrid}>
          {testimonialData.map((testimonial, index) => (
            <TestimonialCard
              key={index}
              avatar={testimonial.avatar}
              name={testimonial.name}
              title={testimonial.title}
              description={testimonial.description}
              showMore={testimonial.showMore}
            />
          ))}
        </div>
        {/* <div className={styles.progressIndicator} /> */}
        {/* <div className={styles.navigationControls}>
          <button className={styles.navButton} aria-label="Previous testimonial">
            <div className={styles.navButtonInner}>
              <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/a6759c140d65932d8cc39d968893ff7f840dcd0668dec0fd6186594344d842e3?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05" alt="" className={styles.navIcon} />
            </div>
          </button>
          <button className={styles.navButton} aria-label="Next testimonial">
            <div className={styles.navButtonInner}>
              <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/5af526b5d953070f5f4f55f60712d8803cd8006f06dfbed994be85430961e78a?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05" alt="" className={styles.navIcon} />
            </div>
          </button>
        </div> */}
      </div>
    </section>
  );
};

export default TestimonialsSection;